import useAppContext from '@groupefungo/react-apollo.core/app/UseContext';

export default () => {
  const { gql, useQuery, useMutation } = useAppContext();

  const UserRolesGql = gql`
 query {
  userRoles {
      id
      name
    }
 }
  `;
  const ClientRolesGql = gql`
query {
  clientRoles {
    id
    gid
    name
  }
}
  `;

  const useUserRolesQuery = () => useQuery(UserRolesGql, {
    fetchPolicy: 'network-only',
  });

  const useClientRolesQuery = () => useQuery(ClientRolesGql, {
    fetchPolicy: 'network-only',
  });

  return {
    useClientRolesQuery,
    useUserRolesQuery,
  };
};
